import React from "react";
import { useTranslation } from "react-i18next";
import { ArrowRight } from "lucide-react";
import { Reveal, Overline } from "./Reveal";

function Node({ children, active }) {
  return (
    <div
      className={`shrink-0 px-4 py-2.5 rounded-lg text-sm font-medium border ${
        active
          ? "bg-navy-700 border-signal/40 text-white shadow-[0_0_24px_rgba(0,85,255,0.18)]"
          : "bg-white/[0.03] border-white/10 text-white/40"
      }`}
    >
      {children}
    </div>
  );
}

export function MobilityShift() {
  const { t } = useTranslation();
  const oldNodes = t("shift.oldNodes", { returnObjects: true });
  const newNodes = t("shift.newNodes", { returnObjects: true });

  return (
    <section className="py-24 md:py-32 border-t border-white/5" data-testid="mobility-shift">
      <div className="container-x">
        <Reveal>
          <Overline>{t("shift.overline")}</Overline>
          <h2 className="mt-4 font-display font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight max-w-3xl">{t("shift.title")}</h2>
        </Reveal>

        <div className="mt-14 grid lg:grid-cols-2 gap-6">
          <Reveal>
            <div className="surface p-8 h-full">
              <p className="overline text-white/40">{t("shift.oldModel")}</p>
              <div className="mt-6 flex flex-wrap items-center gap-3">
                {oldNodes.map((n, i) => (
                  <React.Fragment key={i}>
                    <Node active={false}>{n}</Node>
                    {i < oldNodes.length - 1 && <ArrowRight size={16} className="text-white/20 rtl:rotate-180" />}
                  </React.Fragment>
                ))}
              </div>
              <p className="mt-6 text-sm text-white/45">{t("shift.oldDesc")}</p>
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="surface p-8 h-full relative overflow-hidden">
              <div className="absolute -top-16 -right-16 w-48 h-48 bg-signal/10 rounded-full blur-3xl" />
              <p className="overline text-signal">{t("shift.newModel")}</p>
              <div className="mt-6 flex flex-wrap items-center gap-3">
                {newNodes.map((n, i) => (
                  <React.Fragment key={i}>
                    <Node active>{n}</Node>
                    {i < newNodes.length - 1 && <ArrowRight size={16} className="text-signal/50 rtl:rotate-180" />}
                  </React.Fragment>
                ))}
              </div>
              <p className="mt-6 text-sm text-white/55">{t("shift.newDesc")}</p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}

export default MobilityShift;
